<div class="user-wishlist-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="wishlist-text">{{ data.wishlist.name }}</span>
    <div class="img-container" mat-dialog-close>
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>
  <div class="d-flex align-items-center">
    <img
      src="../../../assets/images/back-icon.svg"
      class="cross-icon"
      mat-dialog-close
    />
    <span class="wishlist-back ms-2" mat-dialog-close
      >Back to all wishlists</span
    >
  </div>
  @if(reachUserWishlists.length>0){
  <div class="table-container">
    <dp-table
      [dataTable]="reachUserWishlists"
      [displayedColumns]="displayColumnData"
      [componentMap]="cellComponentMap"
      [columnConfs]="columnConfs"
      (cellClick)="onCellClick($event)"
    ></dp-table>
  </div>

  <button class="dp-primary-btn transfer-btn" (click)="deleteEntireWishlist()">
    Delete entire wishlist</button
  >}
</div>
<app-loader [isLoading]="isLoading"></app-loader>
